import { useLocation, useParams } from 'react-router-dom';

import { buildRoutes } from '../constants/routes';

type ProfileRoutes = ReturnType<typeof buildRoutes>;

export const useProfileRoutes = (): ProfileRoutes => {
  const location = useLocation();
  const { serviceSlug } = useParams<{ serviceSlug?: string }>();

  const isEpsu = location.pathname.includes('/existing-provider-sign-up/');

  return buildRoutes(isEpsu ? serviceSlug : undefined);
};
